import React from 'react';
import { Box, Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { Button, BodyText } from '../../../ui';
import { SetCurrentUserPayload } from '../../../../store/CurrentUser.types';
import { SymbolsFacebookCircleIcon } from '../../../ui/Icons/SymbolsFacebookCircleIcon';

type FacebookCheckoutSignInButtonProps = {
  onFacebookSignup: () => Promise<SetCurrentUserPayload>;
  onAccountCreated: (success: boolean, userData?: any) => void;
};

export const FacebookCheckoutSignInButton: React.FCWithChildren<FacebookCheckoutSignInButtonProps> = ({
  onFacebookSignup,
  onAccountCreated,
}) => {
  const doFacebookSignup = async () => {
    const userData: any = await onFacebookSignup();
    if (userData.action === 'Signup') {
      onAccountCreated(true);
    }
  };

  return (
    <Button
      appearance="primary-neue"
      style={{ backgroundColor: BrandColor.FacebookBlue }}
      onClick={doFacebookSignup}
      clickTracking="facebook_sso_button_clicked"
      testID="facebookSsoButton_inline"
    >
      <Inline justifyContent="center" alignItems="center" paddingY={10}>
        <SymbolsFacebookCircleIcon color={BrandColor.WhiteWash} width={16} height={16} />
        <Box paddingLeft={10}>
          <BodyText weight="bold" color={BrandColor.WhiteWash}>Continue With Facebook</BodyText>
        </Box>
      </Inline>
    </Button>
  );
};
